import {HeatProfileDtoV1, MoodLightCategory} from 'puffco-api-axios-client';
import React from 'react';
import {useSelector} from 'react-redux';

import {heatProfilesApi} from '../api/apis';
import {
  upsertAccountMoodLights,
  upsertExclusiveMoodLights,
} from '../redux/slices/moodLightSlice';
import {setAccountHeatProfiles} from '../redux/slices/profilesSlice';
import {userSelector} from '../redux/slices/userSlice';
import {useAppDispatch} from '../redux/useAppDispatch';
import {isMoodLightId} from '../types';
import {isDefined} from '../utils/types';
import {useRemoteData} from './useRemoteData';

export const extractMoodLights = (heatProfiles: HeatProfileDtoV1[]) => {
  const exclusiveMoodLights = heatProfiles
    .map(item => {
      if (
        !isMoodLightId(item.light) ||
        item.light.category !== MoodLightCategory.Exclusive
      )
        return;

      return item.light;
    })
    .filter(isDefined);

  const accountMoodLights = heatProfiles
    .map(item => {
      if (
        !isMoodLightId(item.light) ||
        item.light.category !== MoodLightCategory.Custom
      )
        return;

      return item.light;
    })
    .filter(isDefined);

  return {exclusiveMoodLights, accountMoodLights};
};

export const useLoadAccountHeatProfiles = () => {
  const dispatch = useAppDispatch();
  const user = useSelector(userSelector);

  const {isLoading, error, mutate} = useRemoteData(
    {key: 'useLoadHeatProfiles', skip: !user},
    () =>
      heatProfilesApi.getHeatProfiles().then(({data}) => {
        const heatProfiles = data.items;

        const {exclusiveMoodLights, accountMoodLights} =
          extractMoodLights(heatProfiles);

        dispatch(upsertAccountMoodLights(accountMoodLights));
        dispatch(upsertExclusiveMoodLights(exclusiveMoodLights));

        dispatch(setAccountHeatProfiles(heatProfiles));
      }),
  );

  return React.useMemo(
    () => [{isLoading, error}, mutate] as const,
    [isLoading, error, mutate],
  );
};
